"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlineWebSocket = void 0;
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const Interfaces_1 = require("./Interfaces");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
function toKlineItem(item) {
    return {
        date: item.t,
        time: item.t * 1000,
        open: new trade_utils_lib_1.SafeDecimal(item.o).toNumber(),
        high: new trade_utils_lib_1.SafeDecimal(item.h).toNumber(),
        low: new trade_utils_lib_1.SafeDecimal(item.l).toNumber(),
        close: new trade_utils_lib_1.SafeDecimal(item.c).toNumber(),
        volume: new trade_utils_lib_1.SafeDecimal(item.v).toNumber(),
    };
}
class KlineWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.klineCacheData = new CacheData_1.CacheData([], new rxjs_1.Subject());
        this.klinePairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.kline, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.kline, param);
        });
    }
    handleKlineData(pushData) {
        if (!pushData || !pushData.length) {
            return;
        }
        this.klineCacheData.getDataSubject().next(pushData);
    }
    /**
     * @param exchange
     * @param base
     * @param quote
     * @param interval
     */
    getKlineObservable(base, quote, interval, exchange = Interfaces_1.EXCHANGE_PIONEXV2) {
        this.klinePairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote, interval: interval }]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.klineCacheData.getDataSubject().subscribe({
                next: (data) => {
                    const klineItems = data
                        .filter((item) => item.e === exchange && item.b === base && item.q === quote && item.i === interval)
                        .map((item) => {
                        return toKlineItem(item);
                    })
                        .sort((a, b) => a.date - b.date);
                    if (klineItems.length > 0) {
                        observer.next(klineItems);
                    }
                },
                error: (error) => {
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_WARNING, "KlineWebSocket", JSON.stringify(error));
                },
            });
            observer.add(() => {
                subscription.unsubscribe();
                this.klinePairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                        interval: interval,
                    },
                ]);
            });
        });
    }
}
exports.KlineWebSocket = KlineWebSocket;
